import type { TooltipProps } from 'recharts';
import { Text } from '@savvy-kit/foundations/text';
import { Circle } from 'lucide-react';
import { DateTime } from 'luxon';
import numeral from 'numeral';

// This is copied from "recharts/src/component/DefaultTooltipContent"
// DefaultTooltipContent has a typescript compilation error...
type ValueType = number | string | (number | string)[];
type NameType = number | string;

export function GraphTooltip({ active, payload, label }: TooltipProps<ValueType, NameType>) {
  if (!active || !payload?.length) {
    return null;
  }

  const displayText = {
    amount: 'Net worth',
  };

  return (
    <div className="w-[250px] pt-2 px-4 pb-4 rounded-lg bg-dark dark:bg-popover">
      <Text variant="overline" color="light">
        {DateTime.fromISO(label).toFormat('LLLL d, yyyy')}
      </Text>
      {payload
        .filter((x) => x.dataKey)
        .map((x) => {
          return (
            <div key={String(x.dataKey)}>
              <div className="flex flex-row gap-0 items-center justify-between">
                <div className="flex flex-row gap-2 items-center justify-start mr-6">
                  <Circle fill="currentColor" style={{ color: x.color }} size={8} />
                  <Text variant="caption" className="font-bold" color="light">
                    {
                      // @ts-expect-error - FIXME: This is using the wrong type
                      displayText[x.dataKey]
                    }
                  </Text>
                </div>
                <Text variant="caption" color="light">
                  {numeral(x.value).format('$0,0.00')}
                </Text>
              </div>
            </div>
          );
        })}
    </div>
  );
}
